module.exports = __webpack_public_path__ + "0572bfd278685c9f5f89236121a84476.jpg";